import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

export const ludoApi = createApi({
  reducerPath: 'ludoApi',
  baseQuery: dynamicBaseQuery,
  tagTypes: ['Ludo', 'DiceMode', 'LudoMode'],
  endpoints: (builder) => ({
    getLudoInplayRounds: builder.query({
      query: () => ({
        url: '/api/dice/admin/active-games',
        method: 'GET',
      }),
      providesTags: ['Ludo'],
    }),

    getLudoRounds: builder.query({
      query: ({ game = 'ludo', fromDate, toDate, page = 1, limit = 20 } = {}) => {
        const params = new URLSearchParams({ game, page, limit });
        if (fromDate) params.append('fromDate', fromDate);
        if (toDate)   params.append('toDate', toDate);
        return { url: `/api/ludo/admin/rounds?${params.toString()}`, method: 'GET' };
      },
      providesTags: ['Ludo'],
    }),

    getLudoRoundBets: builder.query({
      query: ({ roundId, page = 1, limit = 20 } = {}) => {
        const params = new URLSearchParams({ page, limit });
        if (roundId) params.append('roundId', roundId);
        return { url: `/api/ludo/admin/round-bets?${params.toString()}`, method: 'GET' };
      },
      providesTags: ['Ludo'],
    }),

    getLudoCompletedGames: builder.query({
      query: () => ({
        url: '/api/ludo/admin/completed-games',
        method: 'GET',
      }),
      providesTags: ['Ludo'],
    }),

    getDiceMode: builder.query({
      query: () => ({ url: '/api/dice/admin/mode', method: 'GET' }),
      providesTags: ['DiceMode'],
    }),

    setDiceMode: builder.mutation({
      query: (body) => ({ url: '/api/dice/admin/set-mode', method: 'POST', body }),
      invalidatesTags: ['DiceMode'],
    }),

    getLudoMode: builder.query({
      query: () => ({ url: '/api/ludo/admin/mode', method: 'GET' }),
      providesTags: ['LudoMode'],
    }),

    setLudoMode: builder.mutation({
      query: (body) => ({ url: '/api/ludo/admin/set-mode', method: 'POST', body }),
      invalidatesTags: ['LudoMode'],
    }),

    getLudoCompanyReport: builder.query({
      query: ({ game, userId, fromDate, toDate }) => ({
        url: '/api/dice/admin/company-report',
        method: 'GET',
        params: { game, userId, fromDate, toDate },
      }),
      providesTags: ['Ludo'],
    }),
  }),
});

export const {
  useGetLudoInplayRoundsQuery,
  useGetLudoRoundsQuery,
  useGetLudoRoundBetsQuery,
  useGetLudoCompletedGamesQuery,
  useGetLudoCompanyReportQuery,
  useGetDiceModeQuery,
  useSetDiceModeMutation,
  useGetLudoModeQuery,
  useSetLudoModeMutation,
} = ludoApi;

export default ludoApi;
